/**
 * @voltxampere/ui — Center-tapped transformer (Sprint 44-6, placeholder)
 *
 * PLACEHOLDER. Center-tapped (orta-uçlu) güç transformer'ı —
 * full-wave rectifier + dual-rail (±) supply için klasik. Tek
 * primary winding `inductor` üzerinden gösterir; sekonder dual
 * +V / GND / -V (3-tap) layout Sprint 47+'da (coupled inductor
 * stamp + multiple secondaries).
 *
 * Reference: Generic center-tapped transformer — Hammond 167F12,
 * Triad VPT12-2080. Primary 220 V AC, secondary dual 12-0-12 V AC
 * (24 V_pp). Full-wave bridge alternative + bipolar supply
 * (op-amp lab bench rails ±12 V).
 *
 * Engine zero-diff invariant honored — canonical `inductor` engine
 * type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { inductor } from "../inductor.js";
export const transformerCenterTapped = {
    id: "transformer-center-tapped",
    nameTr: "Center-Tapped Trafo 12-0-12V (placeholder, primary)",
    nameEn: "Center-Tapped Transformer 12-0-12V (placeholder, primary)",
    shortcut: "L",
    category: "passive",
    viewBox: inductor.viewBox,
    terminals: inductor.terminals,
    defaultLabel: "T",
    defaultValue: "CT-12-0-12",
    schemaType: "inductor",
    defaultParams: { inductance: 5 },
    renderSVG: () => inductor.renderSVG(),
};
//# sourceMappingURL=transformer-center-tapped.js.map